import Icon from "../../../components/Icon/Icon";
import {useDropzone} from "react-dropzone";
import {ReactComponent as UploadSvg} from "../../../assets/dragUpload.svg";
import "./PublicDropzone.scss"
import React, {useEffect, useState} from "react";
import PublicPdfViewer from "../PublicPdfViewer/PublicPdfViewer";

const PublicDropzone = ({uploadedFile, setUploadedFile}) => {
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (uploadedFile && uploadedFile.length > 0) {
            const objectUrl = URL.createObjectURL(uploadedFile[0]);
            setPreview(objectUrl)

            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setPreview(null);
        }
    }, [uploadedFile]);

    const {getRootProps, getInputProps} = useDropzone({
        multiple: false,
        maxFiles: 1,
        onDrop: acceptedFiles => {
            if (acceptedFiles.length > 0) {
                setUploadedFile(acceptedFiles);
            }
        }
    });

    return (
        <div {...getRootProps()} className="modal-dnd">
            {preview ? (
                <div className="preview">
                    <PublicPdfViewer preview={preview}/>
                    Signed
                </div>
            ) : (
                <>
                    <input {...getInputProps()}/>

                    <Icon svg={UploadSvg}/>

                    Choose your signed form or drag and drop it here
                </>
            )}
        </div>

    )
}

export default PublicDropzone;